import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_tc--lighter" }
const _hoisted_2 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.wrapperClassList)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.key,
        class: "_flexcol"
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(item.key), 1 /* TEXT */),
        _createElementVNode("span", {
          class: "_fw-eb _tc--dark",
          "data-qa": item.dataQa
        }, _toDisplayString(item.value), 9 /* TEXT, PROPS */, _hoisted_2)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}